<template>
    <div id="map-element" :class="{empty: !moduleData}">
        <div class="module outwards" v-if="moduleData && coordinates" :class="moduleData.Spacing" :id="moduleData.AnchorID">
            <gmap-map ref="locationsMap" :options="mapOptions" :center="coordinates" :zoom="mapZoom">
                <gmap-marker :position="coordinates"></gmap-marker>
            </gmap-map>
            <div class="container" v-if="moduleData.Title && moduleData.ShowTitle" :class="{expand: contentVisible}">
                <div class="map-content" :class="moduleData.Background">
                    <h2 v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</h2>
                    <hr v-if="contentVisible">
                    <template v-if="contentVisible">
                        <p v-if="moduleData.Content" v-html="moduleData.Content"></p>
                        <p><a class="" target="_blank"
                              :href="`https://maps.google.com/?daddr=${moduleData.Latitude},${moduleData.Longitude}`">Get Directions</a></p>
                    </template>

                    <div class="visibility-toggle" v-if="moduleData.Content">
                        <button v-if="contentVisible" @click="contentVisible = false">Show Less<i class="fal fa-chevron-up"></i>
                        </button>
                        <button v-else @click="contentVisible = true">Show More<i class="fal fa-chevron-down"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "MapElement",
        props: {
            component: {
                type: Object,
            }
        },
        data() {
            return {
                mapOptions: {
                    mapTypeControl: false,
                    streetViewControl: true,
                    mapTypeId: 'satellite'
                },
                mapZoom: 16,
                contentVisible: true
            };
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            },
            coordinates() {
                let data = this.moduleData;

                return {
                    lat: parseFloat(data.Latitude),
                    lng: parseFloat(data.Longitude)
                }
            }
        }
    }
</script>
